import React from "react";
import "../styles/Home.css";
export default function Home() {
  return (
    <div className="wrap">
      <div className="container">
        <div className="title">Srivatsan V</div>
        <div className="dev">Developer</div>
      </div>
      <a href="#about" className="angle">
        <i className="fas fa-angle-down" />
      </a>
    </div>
  );
}
